import React, { Component } from 'react';
import classNames from 'classnames'
import styles from './index.css';
import Title from '../../blocks/Title'
import MyIcons from '../../blocks/MyIcons'
import FooterMobile from '../../blocks/FooterMobile'
import {LangChangeEventContext} from '../../contexts/LangContext';

// import AOS from 'aos/dist/aos.js'; 
// import 'aos/dist/aos.css';

export default class MainKitchen extends Component {
  componentWillMount(){
    
  }
  componentDidMount(){
  }
  render() {
    return (
      <LangChangeEventContext.Consumer>
        {({lang}) =>(
          <div className={classNames(styles['kitchenBody'])}> 
            <div className={classNames(styles['backgroundImgWrapper'])}  
                data-aos="fade-up" data-aos-offset="100"
              >  
              <img alt="" src="/assets/img/image.png" className={styles['backgroundImg']} />  
            </div>

            <div className={classNames(styles['contentWrapper'])}>
              <div className={classNames(styles['header'])}  
                  data-aos="fade-up" data-aos-offset="100" data-aos-delay="200"
                >
                <Title colorStyle="black" classStyle={styles['titleStyle']} title={lang.t('kitchenHeader')} text={lang.t('kitchenSubHeader')} />
              </div>
              <div className={classNames(styles['content'])} ref={item => {this.kitchenBody = item}}>  
                <div className={classNames(styles['gallery'],styles['galleryMobile'])}  
                    data-aos="fade-up" data-aos-offset="50" data-aos-delay="400"
                  >    
                  <div className={styles['galleryImgWrapper']} >  
                    <img alt="" src={this.props.ADMIN_URL+JSON.parse(this.props.gallery1)[0].image} className={styles['galleryImg']} />                  
                  </div>                    
                </div>
                <div className={styles['wrapperText']} >  
                  <h3 className={styles['wrapperTextTitle']}  
                      data-aos="fade-up" data-aos-offset="50"
                    >{lang.t('historyTitle')}</h3>
                  <div className={styles['text']}  
                      data-aos="fade-up" data-aos-offset="50"
                    >  
                    <span dangerouslySetInnerHTML={{__html: lang.t('kitchenText1') }} ></span>
                  </div>
                  <div className={styles['textGallery']}  
                      data-aos="fade-up" data-aos-offset="50"
                    >  
                    <div className={styles['imgWr']} >  
                      <img className={styles['img']}  alt="" src={this.props.ADMIN_URL+JSON.parse(this.props.gallery2)[0].image} />
                    </div>  
                    <div className={styles['imgWr']} >  
                      <img className={styles['img']}  alt="" src={this.props.ADMIN_URL+JSON.parse(this.props.gallery2)[1].image} />
                    </div>  
                  </div>
                  <div className={styles['spoon']} >  
                    <MyIcons icon="spoon" width="100px" height="100px"/>     
                  </div>
                  <h3 className={styles['wrapperTextTitle']} 
                      data-aos="fade-up" data-aos-offset="50"
                    >{lang.t('kitchenTitle2')}</h3>
                  <div className={styles['text2']}  
                      data-aos="fade-up" data-aos-offset="50"
                    >  
                    <span dangerouslySetInnerHTML={{__html: lang.t('kitchenText2') }} ></span>
                    <div className={styles['spoon2']} >  
                      <MyIcons icon="spoon" width="100px" height="100px"/>     
                    </div>
                  </div>
                </div>              
                <div className={styles['gallery']}  
                    data-aos="fade-up" data-aos-offset="50"
                  >    
                  <div className={classNames(styles['galleryImgWrapper'],styles['mustD'])} >   
                    <img alt="" src={this.props.ADMIN_URL+JSON.parse(this.props.gallery1)[0].image} className={styles['galleryImg']} />                  
                  </div>  
                  <div className={styles['galleryImgWrapper']} >  
                    <img alt="" src={this.props.ADMIN_URL+JSON.parse(this.props.gallery1)[1].image} className={styles['galleryImg']} />                  
                  </div> 
                </div>                
              </div>  
              <FooterMobile classStyle={styles.footerMobile} />  
            </div>
                    
          </div>
        )}
      </LangChangeEventContext.Consumer>
    );
  }
}




// WEBPACK FOOTER //
// ./src/components/MainKitchenMobile/index.js